import type { CommercialManagerOptions, GetGoodsListParam, GoodsItem } from './types';
import { getGoodsList, syncGoodsList } from './goods';
import { orderAwardList, queryUserCoin, pay } from './pay';

/**
 * 商业化管理类
 */
class CommercialManager {
  private static instance: CommercialManager;

  /**
   * 单例
   **/
  public static getInstance() {
    if (!CommercialManager.instance) {
      CommercialManager.instance = new CommercialManager();
    }
    return CommercialManager.instance;
  }

  // 商业化配置
  public options?: CommercialManagerOptions;

  // 全部商品列表
  private goodsList: GoodsItem[] = [];
  // 推荐商品列表
  private recommendGoodsList: GoodsItem[] = [];

  /**
   * 初始化
   */
  public init(options: CommercialManagerOptions) {
    this.options = options;
  }

  public getRequest(url) {
    if (!this.options?.request?.host) {
      console.error('请先初始化CommercialManager');
      return '';
    }
    let host = this.options?.request?.host;
    if (typeof host === 'function') {
      host = host();
    }
    return host + url;
  }

  /**
   * 同步物品列表
   */
  public syncGoodsList() {
    return new Promise((resolve, reject) => {
      syncGoodsList(CommercialManager.getInstance())
        .then((response) => {
          this.goodsList = (response as any).goodsList || [];
          this.recommendGoodsList = (response as any).recommendGoodsList || [];
          resolve(this.goodsList);
        })
        .catch((e) => {
          console.log(e);
          reject(e);
        });
    });
  }

  /**
   * 获取物品列表
   * @param param 条件参数
   * @param sync 是否先同步最新数据
   */
  public getGoodsList(param: GetGoodsListParam = {}, sync = false): Promise<any> {
    return new Promise((resolve, reject) => {
      if (sync) {
        this.syncGoodsList()
          .then(() => {
            resolve(getGoodsList(this.goodsList, param));
          })
          .catch((e) => {
            reject(e);
          });
      } else {
        resolve(getGoodsList(this.goodsList, param));
      }
    });
  }

  /**
   * 获取推荐物品列表
   * @param param 条件参数
   * @param sync 是否先同步最新数据
   */
  public getRecommendGoodsList(sync = false) {
    return new Promise((resolve, reject) => {
      if (sync) {
        this.syncGoodsList()
          .then(() => {
            resolve(this.recommendGoodsList);
          })
          .catch((e) => {
            reject(e);
          });
      } else {
        resolve(this.recommendGoodsList);
      }
    });
  }

  /**
   * 道聚城下单
   * @param reqData 各业务请求数据结构可能不一样，这里不做类型限制
   * @param showMsgToast 是否显示错误提示
   */
  public orderAwardList(reqData, showMsgToast = false): Promise<void> {
    return orderAwardList(CommercialManager.getInstance(), reqData, showMsgToast);
  }

  /**
   * 道聚城余额
   */
  public queryUserCoin() {
    return queryUserCoin(CommercialManager.getInstance());
  }

  /**
   * 付款
   */
  public pay(reqData) {
    return pay(reqData);
  }
}

export default CommercialManager.getInstance();
